import React from 'react'
import { styles } from '../styles';
import { projects } from '../data/alldata'
import { textVariant } from '../utils/motion';
import { motion } from 'framer-motion'
import ProjectCard from './Item/ProjectCard';
import StarsCanvas from '../3d/Stars';

const Project = () => {
  return (
    <>
    <div
    className="relative w-full h-auto mx-auto  bg-center"
id='project'
>

 
    <motion.div 

initial={{opacity:0.2,y:50}}
transition={{duration:1}}
whileInView={{opacity:1,y:0}}
viewport={{once:true}}
     className='flex flex-col items-center justify-center text-center'>
      
      <h2 className="text-black text-[69px] font-bold">My <span className='text-[#fff000]'> Projects .</span></h2>
      <p className='text-gray-500 font-bold '>
      See my most recent projects below to get an idea of my past experience.
    </p>
    </motion.div>


    {/* <div className="w-full">
      <motion.p variants={fadeIn('','',0.1,1)} className='mt-3 text-white text-[17px] max-w-3xl leading-[30px]'>
      </motion.p>
    </div> */}
    <div className="items-center justify-center mt-20 flex flex-wrap gap-7">
      {projects.map((project,index)=>(
        <ProjectCard key={index} project={project} />
      ))}

    </div>
    </div>
   </>
   
  )
}

export default Project




